import React, {  useState, useEffect } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import csvfile from "../SampleFiles/CSV_TEMPLATE_MAIN.csv";
import tseriesfile from "../SampleFiles/Timeseries2.csv";
import hybridtseries from "../SampleFiles/HybridTimeseries.csv";
import Projectcolors from "../../Utils/Colors";
import { baseURL } from "../../Config/config";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import GlobalLoader from "../CommonC/GlobalLoader";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "1px solid #0078c9",
  boxShadow: 24,
  p: 4,
};

const useStyles = makeStyles({
  button: {
    textTransform: "none",
  },
});

function Importcsv(props) {
  const [selectedFile, setSelectedFile] = useState();
  const [updatedFile, setUpdatedFile] = useState();
  const [isSelected, setIsSelected] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [isChoosed, setIsChoosed] = useState(false);
  
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState("zero");
  const [defaultValue, setDefault] = React.useState(true);
  const [descrnull, setdescrnull] = React.useState(false);
  const [isfill, setisfill] = React.useState(false);
  const [descrcol, setdescrcol] = React.useState("");
  const [nofilefound, setnofilefound] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [descrDuplicate, setdescrduplicate] = React.useState(false);
  const [getLoader, setGetLoader] = React.useState(false);
  const [special, setSpecial] = React.useState(false);

  useEffect(() => {
    if (props.loaded) {
      getLoadCsv();
    }
    checkCsv();
  }, []);

  const getLoadCsv = () => {
    setIsLoading(true);
    sessionStorage.setItem("projectID", props.ProjectID);

    sessionStorage.setItem("projectName", props.projectName);
    fetch(`${baseURL}/getLoadCsv?projectID=${props.ProjectID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())

      .then((data) => {
        if (data.message) {
          setIsUploaded(true);
          setIsSelected(true);
          setIsChoosed(true);
          setnofilefound(false);
          setIsLoading(false);
        } else {
          setIsUploaded(true);
          setnofilefound(true);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("caught it!", err);
      });
  };

  const checkCsv = () => {
    setIsLoading(true);
    const projectID = sessionStorage.getItem("projectID");

    fetch(`${baseURL}/getcheckcsv?projectID=${projectID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())

      .then((data) => {
        if (data.message === 1) {
          setIsUploaded(true);
          setIsSelected(true);
          setIsChoosed(true);
          setnofilefound(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("caught it!", err);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setDefault(false);
    if (event.target.value === "zero") {
      setDefault(true);
    }
  };

  function downloadCSV() {
    var hiddenElement = document.createElement("a");
    hiddenElement.href = csvfile;
    hiddenElement.target = "   ";

    //provide the name for the CSV file to be downloaded
    hiddenElement.download = "CSV_TEMPLATE_MAIN.csv";
    hiddenElement.click();
  }

  function downloadTseries() {
    var hiddenElement = document.createElement("a");
    hiddenElement.href = tseriesfile;
    hiddenElement.target = "   ";

    //provide the name for the CSV file to be downloaded
    hiddenElement.download = "CSV_TEMPLATE_MAIN_TSERIES.csv";
    hiddenElement.click();
  }

    function downloadHTseries() {
      var hiddenElement = document.createElement("a");
      hiddenElement.href = hybridtseries;
      hiddenElement.target = "   ";
  
      //provide the name for the CSV file to be downloaded
      hiddenElement.download = "CSV_TEMPLATE_MAIN_HYBRID_TSERIES.csv";
      hiddenElement.click();
    }
  

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setUpdatedFile(event.target.files[0]);
    // setAllFiles(allFiles => [...allFiles,event.target.files[0],event.target.files[0]])
    setIsChoosed(true);
    setnofilefound(false);
    setIsSelected(false);
    setIsUploaded(false);
  };

  const handlespecialClose = () => {
    setSpecial(false);
  };

  const handleSubmission = () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      const ProjectID = sessionStorage.getItem("projectID");
      const data = [selectedFile, updatedFile];
      data.map((item, i) => {
        formData.append(`File_${i}`, item);
      });
      formData.append("ProjectID", ProjectID);
      fetch(`${baseURL}/upload`, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          setIsLoading(false);
          if (result.message === 1) {
            setdescrnull(true);
            setIsSelected(false);
            setIsUploaded(false);
            setdescrcol(result.descrcol);
            setdescrduplicate(false);
          } else if (result.message === 2) {
            setdescrduplicate(true);
            setIsSelected(false);
            setIsUploaded(false);
            setOpen(false);
            setIsUploaded(false);
            setdescrnull(false);
          } else if (result.message === 3) {
            setdescrnull(false);
            setdescrduplicate(false);
            setIsSelected(false);
            setIsUploaded(false);
            setOpen(true);
          } else if (result.message === 4) {
            setdescrnull(false);
            setdescrduplicate(false);
            setIsSelected(false);
            setIsUploaded(false);
            setSpecial(true);
          } else {
            setdescrnull(false);
            setOpen(false);
            setdescrduplicate(false);
            setIsUploaded(true);
            setIsSelected(true);
            setIsChoosed(true);
            setnofilefound(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error:", error);
        });
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  };

  const NextStep = () => {
    if (isUploaded) {
      props.handleNextStep();
    }
  };

  const removenull = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    const body = {
      option: selectedValue,
      ProjectID,
    };

    try {
      fetch(`${baseURL}/removenull`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          setisfill(true);
          setdescrnull(false);
          setIsUploaded(true);
          setIsSelected(true);
          setIsChoosed(true);
          setGetLoader(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setGetLoader(false);
        });
    } catch (error) {
      console.log("error", error);
      setGetLoader(false);
    }
  };

  const classes = useStyles();

  return (
  <Box>
    {/* Special Character Dialog */}
    <Dialog open={special} onClose={handlespecialClose}>
      <DialogTitle
        sx={{
          color: "#9e0b22",
          fontSize: "12px",
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        Special Characters not accepted in CSV:
        <br />
        @ _ ! # $ % ^ & * ( ) &lt; &gt; ? / | {'{ }'} ~ :
      </DialogTitle>
    </Dialog>

    <Box
      sx={{
        width: 500,
        margin: "60px auto",
        padding: 4,
        borderRadius: "24px",
        background: "rgba(255,255,255,0.9)",
        backdropFilter: "blur(20px)",
        border: "2px solid #0078c9",
        boxShadow: "0 12px 35px rgba(0,0,0,0.15)",
        position: "relative",
      }}
    >
      {/* HEADER */}
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#0078c9",
          mb: 1,
        }}
      >
        Upload CSV
      </Typography>

      <Typography
        sx={{
          fontSize: "12px",
          color: "#666",
          mb: 3,
        }}
      >
        Upload CSV file to continue analysis
      </Typography>

      {/* Upload area */}

      <Box
        sx={{
          border: "2px dashed #0078c9",
          borderRadius: "18px",
          padding: 4,
          textAlign: "center",
          background: "#f8fbff",
        }}
      >
        <input
          disabled={!props.editAccess}
          type="file"
          accept=".csv"
          onChange={changeHandler}
          style={{
            fontSize: "12px",
          }}
        />

        <Typography
          sx={{
            mt: 2,
            fontSize: "12px",
            color: "#555",
          }}
        >
          Choose CSV file for upload
        </Typography>
      </Box>

      {/* Upload button */}

      {isLoading ? (
        <CircularProgress
          sx={{
            color: "#0078c9",
            mt: 3,
            display: "block",
            marginInline: "auto",
          }}
        />
      ) : (
        <Button
          onClick={handleSubmission}
          disabled={!isChoosed || !props.editAccess}
          fullWidth
          sx={{
            mt: 3,
            height: 45,
            borderRadius: "12px",
            backgroundColor: "#0078c9",
            color: "#fff",
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "none",

            "&:hover": {
              backgroundColor: "#0060a0",
            },
          }}
        >
          Upload CSV
        </Button>
      )}

      {/* ALERTS */}

      {descrDuplicate && (
        <Alert
          severity="error"
          sx={{
            mt: 2,
            borderRadius: 3,
            fontSize: "12px",
          }}
        >
          Duplicate values found in description row
        </Alert>
      )}

      {descrnull && (
        <Alert
          severity="error"
          sx={{
            mt: 2,
            borderRadius: 3,
            fontSize: "12px",
          }}
        >
          Description cannot be blank in column {descrcol}
        </Alert>
      )}

      {isUploaded && (
        <Alert
          severity={nofilefound ? "error" : "success"}
          sx={{
            mt: 2,
            borderRadius: 3,
            fontSize: "12px",
          }}
        >
          {selectedFile
            ? `${selectedFile.name} uploaded successfully`
            : nofilefound
            ? "Please Upload File"
            : "File Loaded Successfully"}
        </Alert>
      )}

      {/* DOWNLOAD LINKS */}

      <Box
        sx={{
          mt: 3,
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        {[
          {
            text: "Download CSV Template",
            click: downloadCSV,
          },
          {
            text: "Download TSeries Template",
            click: downloadTseries,
          },
          {
            text: "Download Hybrid Time Series Template",
            click: downloadHTseries,
          },
        ].map((item) => (
          <Typography
            key={item.text}
            onClick={item.click}
            sx={{
              fontSize: "12px",
              color: "#0078c9",
              cursor: "pointer",
              fontWeight: 500,

              "&:hover": {
                color: "#9e0b22",
                pl: 1,
                transition: ".3s",
              },
            }}
          >
            {item.text}
          </Typography>
        ))}
      </Box>

      {/* NEXT BUTTON */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 4,
        }}
      >
        <Button
          disabled={!isSelected}
          onClick={NextStep}
          sx={{
            minWidth: 60,
            width: 60,
            height: 60,
            borderRadius: "50%",
            backgroundColor: "#0078c9",

            "&:hover": {
              backgroundColor: "#9e0b22",
            },
          }}
        >
          <ChevronRightIcon
            sx={{
              color: "#fff",
              fontSize: 28,
            }}
          />
        </Button>
      </Box>

      {/* Missing data modal */}

      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <CloseIcon
            onClick={handleClose}
            sx={{
              float: "right",
              cursor: "pointer",
              color: "#9e0b22",
            }}
          />

          <Typography
            sx={{
              fontSize: "12px",
              color: "#0078c9",
              fontWeight: 700,
              mb: 2,
            }}
          >
            Missing Data Warning
          </Typography>

          <Typography
            sx={{
              fontSize: "12px",
              mb: 3,
            }}
          >
            Fill missing values with:
          </Typography>

          <RadioGroup sx={{ gap: 1 }}>
            {["zero", "mean", "median"].map((item) => (
              <FormControlLabel
                key={item}
                value={item}
                onChange={handleChange}
                control={
                  <Radio
                    sx={{
                      color: "#0078c9",
                      "&.Mui-checked": {
                        color: "#9e0b22",
                      },
                    }}
                  />
                }
                label={
                  <Typography sx={{ fontSize: "12px" }}>
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </Typography>
                }
              />
            ))}
          </RadioGroup>

          <Button
            onClick={removenull}
            fullWidth
            sx={{
              mt: 3,
              height: 45,
              borderRadius: "12px",
              backgroundColor: "#0078c9",
              color: "#fff",
              fontSize: "12px",

              "&:hover": {
                backgroundColor: "#9e0b22",
              },
            }}
          >
            Recondition
          </Button>

          {isfill && (
            <Alert
              severity="success"
              sx={{
                mt: 2,
                fontSize: "12px",
              }}
            >
              Success! Missing values filled.
            </Alert>
          )}
        </Box>
      </Modal>
    </Box>
  </Box>
);
}

export default Importcsv;
